import { default as axiosDefault } from 'axios';
import { parseOtherRecipients } from 'pages/EmailModule/otherRecipients';

import {
  axiosFormInstance as axiosForm,
  axiosInstance as axios,
} from './index';

export const sendEmail = async (
  communityId: string,
  data: any,
  FIELDS,
  captchaToken: string,
) => {
  const formData = await new FormData();

  formData.append(FIELDS.SEND_TO_ME, data[FIELDS.SEND_TO_ME]);
  formData.append(FIELDS.SUBJECT, data[FIELDS.SUBJECT]);
  formData.append('body', data[FIELDS.MESSAGE]);
  formData.append('captchaToken', captchaToken);
  formData.append(
    'recipients',
    JSON.stringify([...new Set(data[FIELDS.RECIPIENTS])]),
  );
  formData.append(
    FIELDS.OTHER_RECIPIENTS,
    JSON.stringify([
      ...new Set(parseOtherRecipients(data[FIELDS.OTHER_RECIPIENTS])),
    ]),
  );

  if (data.attachments && data.attachments.length > 0) {
    const detail = data.attachments.map((file) => ({
      ext: file.type ? file.type.split('/')?.[1] : undefined,
      filename: file.name,
      mimetype: file.type,
      size: file.size / 1000000000,
    }));

    const presignResponse = await axios.post(
      `/communities/${communityId}/mediaPresignedUrl`,
      { mediaDetail: JSON.stringify(detail) },
    );

    const { presignedUrls, mediaUrls } = presignResponse.data;

    const uploadPromises = presignedUrls.map((url, index) => {
      const mediaFile = data.attachments[index];
      if (url && mediaFile) {
        return axiosDefault.put(url, mediaFile, {
          headers: {
            'Content-Type': mediaFile.type,
          },
        });
      }
      return Promise.resolve();
    });

    await Promise.all(uploadPromises);

    const s3Attachments = mediaUrls.map((mediaUrl, index) => ({
      mediaUrl,
      filename: data.attachments[index].name,
    }));

    formData.append('s3Attachments', JSON.stringify(s3Attachments));
  }

  const response = await axiosForm.post(
    `/communities/${communityId}/sendMail`,
    formData,
  );

  return response.data;
};
